import React, { useEffect, useState } from "react";
import RequestHandler from "../../util/RequestHandler";
import {
  Table,
  Empty,
  Col,
  Row,
  Button,
  Drawer,
  Popconfirm,
  notification,
  Tooltip, Tabs
} from "antd";
import {
  OrderedListOutlined,
  PlusOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  EditOutlined,
  DeleteOutlined
} from "@ant-design/icons";
import { Link, useHistory } from "react-router-dom";
import { odata, queryHelper } from "../Filters/Helper";
import { RowHelper } from "util/TableHelper";
import AccountTransactionRuleAddForm from "../Forms/AccountTransactionRuleAddForm";
import AccountTransactionRuleUpdateForm from "../Forms/AccountTransactionRuleUpdateForm";
import AccountTransactionRuleListFilter from "../Filters/AccountTransactionRuleListFilter";
import EntityPermissionAddForm from "../Forms/EntityPermissionAddForm";
import EntityPermissionUpdateForm from "../Forms/EntityPermissionUpdateForm";

const AccountTransactionRuleList = (props) => {
  const [tableData, setTableData] = useState({
    data: [],
    loading: true,
    total: 0,
  });
  const [formOptions, setFormOptions] = useState({
    corparisonTypes: [],
    permissibleProperties: [],
  });
  const [tableDataQueryOptions, setTableDataQueryOptions] = useState({
    ...queryHelper.getDefaultTableDataQueryOptions(),
    activeTab: "0"
  });
  const [dataState, setDataState] = useState([{ skip: 0, take: 20 }]);
  const [currentPage, setCurrentPage] = useState(1);
  const [addFormVisibility, setAddFormVisibility] = useState(false);
  const [updateFormVisibility, setUpdateFormVisibility] = useState(false);
  const [updateFormData, setUpdateFormData] = useState({});
  const [isUseForErp, setIsUseForErp] = useState(false);
  const [tenantUserId, setTenantUserId] = useState();
  const [updateFirmFormData, setUpdateFirmFormData] = useState({});
  const [isActiveAutoTransfer, setIsActiveAutoTransfer] = useState(false);

  const history = useHistory();

  useEffect(() => {
    checkForUseErp();
    setFilterValues();
    getTableData();
    if (tableDataQueryOptions.activeTab == "1")
      getEntityPermissionOptions();
  }, [tableDataQueryOptions]);

  const getEntityPermissionOptions = () => {
    RequestHandler.get(
      "/EntityPermission/Options/Firm"
    ).then((response) => {
      setFormOptions(response);
    });
    RequestHandler.get(`/TenantUser/GetById`).then((response) => {
      if (response) {
        setTenantUserId(response.id);
      }
    });
  };
  const getTableData = () => {
    setTableData({
      ...tableData,
      loading: true,
    });

    const { skip, take, filter, activeTab } = tableDataQueryOptions;
    const order = "&$orderby=addDate desc";
    let query = "";
    const conditions = [];
    if (filter) {
      conditions.push(filter);
    }

    if (conditions.length > 0)
      query = `${conditions.join(" and ")}`;
    if (activeTab == "0") {
      query = `&$filter=Name ne 'Diğer'${conditions.length > 0 ? ` and ${query}` : ''}`;
      RequestHandler.get(
        `/AccountTransactionRule?$count=true${query}${order}&$skip=${skip}&$top=${take}`
      ).then((response) => {
        setTableData({
          data: response.value,
          loading: false,
          total: response["@odata.count"],
        });
      });
    } else {
      query = `&$filter=entityType eq 'Firm'${conditions.length > 0 ? ` and ${query}` : ''}`;
      RequestHandler.get(
        `/EntityPermission?$count=true${query}&$skip=${skip}&$top=${take}`
      ).then((response) => {
        setTableData({
          data: response.value,
          loading: false,
          total: response["@odata.count"],
        });
      });
    }
  };

  const checkForUseErp = () => {
    RequestHandler.get(`/AccountTransactionRule/CheckForUseErp`).then(
      (response) => {
        setIsUseForErp(response.isUseErp);
        setIsActiveAutoTransfer(response.isAutoTransferDependOnRules)
      }
    );
  };

  const onAddAccountTransactionRuleSuccess = () => {
    getTableData();
    setAddFormVisibility(false);
  };

  const handleOnClickUpdate = (record) => {
    RequestHandler.get(`/AccountTransactionRule/GetById/${record.id}`).then(
      (response) => {
        if (response) {
          setUpdateFormData(response);
          setUpdateFormVisibility(true);
        }
      }
    );
  };

  const onUpdateAccountTransactionRuleSuccess = () => {
    getTableData();
    setUpdateFormVisibility(false);
  };

  const setFilterValues = () => {
    const filterValues = {
      ...tableDataQueryOptions.values,
      skip: tableDataQueryOptions.skip,
      take: tableDataQueryOptions.take,
      current: tableDataQueryOptions.current,
      order: tableDataQueryOptions.order,
      filter: tableDataQueryOptions.filter,
    };
    const queryString = queryHelper.getQueryFromValues(filterValues);

    history.replace({
      pathname: window.location.pathname,
      search: queryString,
    });
  };

  const onTabChange = (tabKey) => {
    setTableDataQueryOptions({
      ...tableDataQueryOptions,
      skip: 0,
      current: 1,
      activeTab: tabKey,
    });
  };

  const openNotificationWithIcon = (type) => {
    notification[type]({
      message: "Uyarı",
      description: "Pasif olan kurallar güncellenemez.",
    });
  };
  const firmRuleColumns = [
    {
      title: "Yetkilendirilen Alan",
      dataIndex: "propertyDisplayName",
    },
    {
      title: "Karşılaştırma Türü",
      dataIndex: "corparisonTypeName",
    },
    {
      title: "Karşılaştırılacak Değer",
      dataIndex: "valueDisplayName",
      render: (data, row) => (data ? data : row.value),
    },
    {
      title: "Düzenle",
      dataIndex: "id",
      align: "center",
      render: (data, row) => (
        <a onClick={() => handleFirmRuleOnClickUpdate(row)}>
          <EditOutlined style={{ color: "orange", fontSize: "130%" }} />
        </a>
      ),
    },
    {
      title: "Sil",
      dataIndex: "id",
      align: "center",
      render: (data, record) => (
        <Popconfirm
          title="Silmek istiyor musunuz?"
          okText="Evet"
          cancelText="Hayır"
          onConfirm={() => handleFirmRuleOnClickDelete(data)}
        >
          <a>
            <DeleteOutlined style={{ color: "red", fontSize: "130%" }} />
          </a>
        </Popconfirm>
      ),
    },
  ];
  const handleFirmRuleOnClickUpdate = (record) => {
    debugger
    RequestHandler.get(`/EntityPermission/GetById/${record.id}`).then(
      (response) => {
        setUpdateFirmFormData(response);
        setUpdateFormVisibility(true);
      }
    );
  };
  const handleFirmRuleOnClickDelete = (id) => {
    RequestHandler.delete(`/EntityPermission/${id}`).then((response) => {
      if (response.success) {
        getTableData();
      }
    });
  };
  const columns = [
    {
      title: "Kural Adı",
      dataIndex: "name",
      key: "name",
      align: "left",
      width: "11%",
      render: (text) => {
        if (!text) return "";

        return (
          <Tooltip title={text}>
            {text.substring(0, 25).length < 25
              ? text.substring(0, 25) + ""
              : text.substring(0, 25) + "..."}
          </Tooltip>
        );
      },
    },
    {
      title: "Kural Metni",
      dataIndex: "key",
      key: "key",
      align: "left",
      width: "15%",
      render: (text) => {
        if (!text) return "";

        return (
          <Tooltip title={text}>
            {text.substring(0, 25).length < 25
              ? text.substring(0, 25) + ""
              : text.substring(0, 25) + "..."}
          </Tooltip>
        );
      },
    },
    {
      title: "Ek Kural Metni",
      dataIndex: "additionalKey",
      key: "additionalKey",
      align: "left",
      width: "15%",
      render: (text) => {
        if (!text) return "";

        return (
          <Tooltip title={text}>
            {text.substring(0, 25).length < 25
              ? text.substring(0, 25) + ""
              : text.substring(0, 25) + "..."}
          </Tooltip>
        );
      },
    },
    {
      title: "Açıklama",
      dataIndex: "replaceKey",
      key: "replaceKey",
      align: "left",
      width: "15%",
      render: (text) => {
        if (!text) return "";

        return (
          <Tooltip title={text}>
            {text.substring(0, 25).length < 25
              ? text.substring(0, 25) + ""
              : text.substring(0, 25) + "..."}
          </Tooltip>
        );
      },
    },

    // {
    //   title: "Belge Tipi",
    //   dataIndex: "documentType",
    //   key: "documentType",
    //   align: "left",
    //   render: (text) => {
    //     if (!text) return "";

    //     return (
    //       <Tooltip title={text}>
    //         {text.substring(0, 25).length < 25
    //           ? text.substring(0, 25) + ""
    //           : text.substring(0, 25) + "..."}
    //       </Tooltip>
    //     );
    //   },
    // },

    {
      title: isUseForErp ? "İşlem Tipi" : "Bayi Sınıfı",
      dataIndex: isUseForErp ? "processType" : "firmClassName",
      key: isUseForErp ? "processType" : "firmClassName",
      align: "left",
      width: "11%",
      render: (text) => {
        if (!text) return "";

        return (
          <Tooltip title={text}>
            {text.substring(0, 25).length < 25
              ? text.substring(0, 25) + ""
              : text.substring(0, 25) + "..."}
          </Tooltip>
        );
      },
    },

    {
      title: isUseForErp ? "Erp Kodu" : "Bayi Adı",
      dataIndex: isUseForErp ? "erpCode" : "firmName",
      key: isUseForErp ? "erpCode" : "firmName",
      align: "left",
      width: "11%",
      render: (text) => {
        if (!text) return "";

        return (
          <Tooltip title={text}>
            {text.substring(0, 25).length < 25
              ? text.substring(0, 25) + ""
              : text.substring(0, 25) + "..."}
          </Tooltip>
        );
      },
    },

    // {
    //   title: "Muhasebe Kodu",
    //   dataIndex: "accountingCode",
    //   key: "accountingCode",
    //   align: "left",
    //   render: (text) => {
    //     if (!text) return "";

    //     return (
    //       <Tooltip title={text}>
    //         {text.substring(0, 25).length < 25
    //           ? text.substring(0, 25) + ""
    //           : text.substring(0, 25) + "..."}
    //       </Tooltip>
    //     );
    //   },
    // },

    {
      title: "Referans Kodu",
      dataIndex: "referenceCode",
      key: "referenceCode",
      align: "left",
      width: "11%",
      render: (text) => {
        if (!text) return "";

        return (
          <Tooltip title={text}>
            {text.substring(0, 25).length < 25
              ? text.substring(0, 25) + ""
              : text.substring(0, 25) + "..."}
          </Tooltip>
        );
      },
    },

    {
      title: "Proje Kodu",
      dataIndex: "projectCode",
      key: "projectCode",
      align: "left",
      width: "11%",
      render: (text) => {
        if (!text) return "";

        return (
          <Tooltip title={text}>
            {text.substring(0, 25).length < 25
              ? text.substring(0, 25) + ""
              : text.substring(0, 25) + "..."}
          </Tooltip>
        );
      },
    },

    // {
    //   title: "Sorumluluk Merkezi",
    //   dataIndex: "centerOfResponsibilityCode",
    //   key: "centerOfResponsibilityCode",
    //   align: "left",
    //   render: (text) => {
    //     if (!text) return "";

    //     return (
    //       <Tooltip title={text}>
    //         {text.substring(0, 25).length < 25
    //           ? text.substring(0, 25) + ""
    //           : text.substring(0, 25) + "..."}
    //       </Tooltip>
    //     );
    //   },
    // },

    {
      title: "Düzenle",
      dataIndex: "id",
      align: "center",
      render: (data, row) =>
        tableData.total >= 1 ? (
          row.isActive ? (
            <a onClick={() => handleOnClickUpdate(row)}>
              <EditOutlined style={{ color: "orange", fontSize: "130%" }} />
            </a>
          ) : (
            <a
              onClick={() => {
                openNotificationWithIcon("warning");
              }}
              style={{
                color: "orange",
                fontSize: "130%",
                paddingBottom: "20px",
              }}
            >
              <EditOutlined />
            </a>
          )
        ) : null,
    },
    {
      title: "Durum",
      dataIndex: "id",
      align: "center",
      render: (data, row) =>
        row.isActive ? (
          <Popconfirm
            title="Pasif yapmak istiyor musunuz?"
            okText="Evet"
            cancelText="Hayır"
            onConfirm={() => handleActivePassive(data)}
          >
            <a style={{ color: "green", fontSize: "130%" }}>
              <CheckCircleOutlined />
            </a>
          </Popconfirm>
        ) : (
          <Popconfirm
            title="Aktif yapmak istiyor musunuz?"
            okText="Evet"
            cancelText="Hayır"
            onConfirm={() => handleActivePassive(data)}
          >
            <a style={{ color: "red", fontSize: "130%" }}>
              <CloseCircleOutlined />
            </a>
          </Popconfirm>
        ),
    },
  ];

  const detailColumns = [
    {
      title: "Banka Hesabı",
      dataIndex: "tenantAccountName",
    },
    {
      title: "Hesap Hareketi İşlem Tipi",
      dataIndex: "transactionProcessTypeName",
    },
  ];

  const onClearTableFilter = () => {
    setTableDataQueryOptions({
      ...tableDataQueryOptions,
      skip: 0,
      current: 1,
      filter: "",
      values: {},
    });
  };

  const onFinishTableFilter = (query, values) => {
    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        skip: 0,
        current: 1,
        filter: query,
        values: values,
      };
    });
  };

  const paging = (p, filters, sorter) => {
    let orderBy = "";
    if (sorter.columnKey && sorter.order) {
      orderBy =
        "&" +
        (sorter.order === "ascend"
          ? odata.orderBy(sorter.columnKey)
          : odata.orderByDesc(sorter.columnKey));
    }
    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        skip: (p.current - 1) * prevState.take,
        take: p.pageSize,
        current: p.current,
      };
    });
  };

  const dataStateChange = (e) => {
    setTableData(e);
  };

  const handleActivePassive = (id) => {
    RequestHandler.delete(`/AccountTransactionRule/${id}`).then((response) => {
      if (response.success) {
        getTableData();
      }
    });
  };

  return (
    <>
      <Row>
        <Col xs={24} md={12} lg={16}>
          <p style={{ fontSize: "120%", marginTop: -5 }}>
            <OrderedListOutlined /> KURAL LİSTESİ
          </p>
        </Col>
        <Col xs={24} md={12} lg={8} style={{ textAlign: "right" }}>
          <Button
            type="primary"
            onClick={() => {
              setAddFormVisibility(true);
            }}
            style={{ marginBottom: 0 }}
          >
            <PlusOutlined /> Kural Ekle
          </Button>
        </Col>
      </Row>

      <Tabs
        defaultActiveKey={tableDataQueryOptions.activeTab}
        onChange={onTabChange}
      >
        <Tabs.TabPane tab="Hareket Kural Listesi" key="0">
          <AccountTransactionRuleListFilter
            data={tableDataQueryOptions.values}
            onClearFilter={onClearTableFilter}
            onFinishFilter={onFinishTableFilter}
            style={{ marginTop: 12, marginBottom: 12 }}
          />
        </Tabs.TabPane>
        <Tabs.TabPane tab="Bayi Kural Listesi" key="1" />
      </Tabs>
      <Row>
        <Col span={24}>
          <Table
            locale={{
              emptyText: (
                <Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description="Veri Yok"
                />
              ),
            }}
            style={{
              overflowX: "auto",
              maxHeight: "100%",
              width: "100%",
            }}
            expandable={ tableDataQueryOptions.activeTab == "0" ?  {
              expandedRowRender: (row) =>
                RowHelper.renderRowDetail({
                  data: row,
                  columns: detailColumns,
                }),
            } : null}
            columns={tableDataQueryOptions.activeTab == "0" ? columns : firmRuleColumns}
            onDataStateChange={dataStateChange}
            dataSource={tableData.data}
            loading={tableData.loading}
            pageable={true}
            onChange={paging}
            pagination={{
              defaultPageSize: tableDataQueryOptions.take,
              pageSizeOptions: ["15", "25", "50", "100"],
              total: tableData.total,
              current: tableDataQueryOptions.current,
            }}
            sortable={true}
            rowKey="id"
          ></Table>
        </Col>
      </Row>
      <Drawer
        id="addAccountTransactionRuleDrawer"
        title="Kural Ekle"
        bodyStyle={{ padding: 24 }}
        width={500}
        onClose={() => setAddFormVisibility(false)}
        visible={tableDataQueryOptions.activeTab == "0" && addFormVisibility}
      >
        <AccountTransactionRuleAddForm
          onSuccess={onAddAccountTransactionRuleSuccess}
          isUseForErp={isUseForErp}
          isActiveAutoTransfer={isActiveAutoTransfer}
        />
      </Drawer>
      <Drawer
        id="addFirmRuleDrawer"
        title="Kural Ekle"
        bodyStyle={{ padding: 24 }}
        width={500}
        onClose={() => setAddFormVisibility(false)}
        visible={tableDataQueryOptions.activeTab == "1" && addFormVisibility}
      >
        <EntityPermissionAddForm
          data={{
            entityType: "Firm",
            tenantUserId: tenantUserId,
          }}
          options={formOptions}
          onSuccess={onAddAccountTransactionRuleSuccess}
        />
      </Drawer>
      <Drawer
        id="updateAccountTransactionRuleDrawer"
        title="Kural Güncelle"
        bodyStyle={{ padding: 24 }}
        width={500}
        onClose={() => setUpdateFormVisibility(false)}
        visible={tableDataQueryOptions.activeTab == "0" && updateFormVisibility}
      >
        <AccountTransactionRuleUpdateForm
          data={updateFormData}
          onSuccess={onUpdateAccountTransactionRuleSuccess}
          isUseForErp={isUseForErp}
          isActiveAutoTransfer={isActiveAutoTransfer}
        />
      </Drawer>
      <Drawer
        id="updateFirmRuleDrawer"
        title="Kural Güncelle"
        bodyStyle={{ padding: 24 }}
        width={500}
        onClose={() => setUpdateFormVisibility(false)}
        visible={tableDataQueryOptions.activeTab == "1" && updateFormVisibility}
      >
        <EntityPermissionUpdateForm
          data={updateFirmFormData}
          onSuccess={onUpdateAccountTransactionRuleSuccess}
          options={formOptions}
        />
      </Drawer>
    </>
  );
};

export default AccountTransactionRuleList;
